/**
 * Non-fan section creation logic
 */
import { IBotSection, ISection } from '../../../models';
import {
  DEFAULT_COEFFICIENTS,
  SectionCreationContext,
} from '../../../models/bot';
import { dispatchMutation } from '../../../utils/dispatch.utils';
import { ahuApi } from '../../../services';
import { createDrainPan } from '../designAccessories/createDrainPan';
import { PLENUM_LENGTH } from '../../data/bot';

/**
 * Creates a non-fan section
 */
export async function createNotCreatedSection(
  botSection: IBotSection,
  modelData: any,
  context: SectionCreationContext,
  orderRate: number,
  extraLength: number,
  nextSection: IBotSection | null,
  floor_innerliner_id: number | null,
  casing_innerliner_id: number | null,
): Promise<any> {
  const {
    tunnelId,
    sizerSettings,
    casingInsulationId,
    getOptions,
    onProgress,
  } = context;
  const sectionLength = botSection.type === 'plenum' ? PLENUM_LENGTH : 12;
  const sectionTag =
    botSection.type === 'coil'
      ? `${botSection.duty_id === 1 ? 'Cooling' : 'Heating'} Coil`
      : '';

  // Use the createSection mutation endpoint (same as useCreateSection hook)
  const resp: ISection = await dispatchMutation(
    ahuApi.endpoints.createSection,
    {
      body: {
        length: sectionLength,
        sitting_on_id: null,
        split: false,
        tag: sectionTag,
        tunnel_id: tunnelId,
        casing_insulation_id:
          sizerSettings?.casing_insulation_id || casingInsulationId,
        casing_innerliner_id: casing_innerliner_id,
        floor_innerliner_id: floor_innerliner_id,
        eadb_temp: modelData?.input?.eadb_temp,
        eawb_temp: modelData?.input?.eawb_temp,
        ladb_temp: modelData?.input?.ladb_temp,
        lawb_temp: modelData?.input?.lawb_temp,
        air_stream_id: botSection.air_stream_id,
        airflow: botSection.airflow,
        order_rate: orderRate,
      },
    },
    getOptions(),
  );
  botSection.model = resp;

  let length = extraLength;
  if (orderRate === 1 && nextSection?.type === 'fan') {
    length = extraLength + (resp.length - resp.aw_length);
  }

  // Create drain pan for cooling coil
  let drainPan: any = null;
  if (botSection.type === 'coil' && botSection.duty_id === 1) {
    drainPan = await createDrainPan(resp.id, context);
  }

  onProgress?.(DEFAULT_COEFFICIENTS.create_section); // create_section coefficient

  return { resp, length, sectionTag, drainPan };
}
